import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { generateQueryParamsFromStringQuery } from '@/utils/helper';
import { useTranslate } from '@/locale';
import { useEffectNextRender } from '@/utils/hooks';
import LanguagePreferenceBarView from './LanguagePreferenceBarView';

const LanguagePreferenceBar = () => {
  const [isEnActive, setIsEnActive] = useState<boolean>(false);
  const location = useLocation();
  const {
    changeLanguage,
    setLNGQueryParams,
    checkStorageWhenLngQueryIsNotExist,
    translate,
  } = useTranslate();
  const queryParamsObject = generateQueryParamsFromStringQuery(location.search);

  const changeActive = (param: boolean) => {
    setIsEnActive(param);
    setLNGQueryParams(param ? 'en' : 'id');
  };
  const setInitValueOfTheSwitchLang = () => {
    const { lng } = queryParamsObject;
    if (lng && lng === 'en') {
      setIsEnActive(true);
    }
  };

  const changeLanguageBasedOnParamsQuery = () => {
    const { lng } = queryParamsObject;
    if (lng && lng === 'en') {
      changeLanguage('en');
      return;
    }
    changeLanguage('id');
  };

  useEffect(() => {
    checkStorageWhenLngQueryIsNotExist();
    setInitValueOfTheSwitchLang();
  }, []);

  useEffectNextRender(() => {
    changeLanguageBasedOnParamsQuery();
  }, [location.search]);
  return (
    <LanguagePreferenceBarView
      changeActive={changeActive}
      isEnActive={isEnActive}
      translate={translate}
    />
  );
};

export default LanguagePreferenceBar;
